var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bg)?_c('div',{staticClass:"cpt-rotating-bg"},[_c('img',{attrs:{"src":_vm.bg,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }